import { fromEvent } from 'rxjs/observable/fromEvent';

export class Browser {

  getEventAsObservable(event) {
    return fromEvent(document, event);
  }

  getEventsAsObservable(events) {
    return events.map(this.getEventAsObservable)
  }

  getCurrentUrl() {
    return window.location.href;
  }

  redirectToUrl(url) {
    window.location.assign(url);
  }

  changeUrlWithoutReload(url) {
    window.history.pushState(null, null, url);
  }

  get sessionStorage() {
    return window.sessionStorage;
  }

  get localStorage() {
    return window.localStorage;
  }
  
  supportsSessionStorage () {
    try {
        if (!window.sessionStorage) return false; // Test availability
        window.sessionStorage.setItem('storageTest', 'A'); // Try write
        if (window.sessionStorage.getItem('storageTest') != 'A') return false; // Test read/write
        window.sessionStorage.removeItem('storageTest'); // Try delete
        if (window.sessionStorage.getItem('storageTest')) return false; // Test delete
        return true; // Success
    } catch (e) {
        return false;
    }
  }

  supportsLocalStorage () {
    try {
        if (!window.localStorage) return false; // Test availability
        window.localStorage.setItem('storageTest', 'A'); // Try write
        if (window.localStorage.getItem('storageTest') != 'A') return false; // Test read/write
        window.localStorage.removeItem('storageTest'); // Try delete
        if (window.localStorage.getItem('storageTest')) return false; // Test delete
        return true; // Success
    } catch (e) {
        return false;
    }
  }  
}
